export default "__VITE_ASSET__DpJm5fvp__"